import { render, staticRenderFns } from "./withdrawalKanban.vue?vue&type=template&id=6ebc7bc2&"
import script from "./withdrawalKanban.vue?vue&type=script&lang=js&"
export * from "./withdrawalKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports